<template>
    <div class="container">
        <HomeHeader />
        <ReportHeader>
            <div class="show_date">
                <ShowYear :year="year" />
                <ShowMonth :months="[month]" style="margin-left: 57px" />
            </div>
        </ReportHeader>
        <BgContainer>
            <main>
                <div class="title_row">
                    <PageTitle title="收藏夹" :isBack="true" to="/" />
                </div>
                <div class="second_and_list">
                    <div class="second_plate">
                        <div class="all" @click="currentFavoriteId = ''">全&nbsp;&nbsp;&nbsp;&nbsp;部</div>
                        <div class="li" v-for="item in favoriteList" :key="item.id" :class="item.id === currentFavoriteId ? 'active' : ''" @click="currentFavoriteId = item.id">
                            <h1>{{ item.favoriteName }}</h1>
                            <span>({{ item.total }})</span>
                            <div class="oper" v-if="item.deftFlag !== 1 && item.id !== currentFavoriteId">
                                <div class="btn del" @click.stop="openDC(item)">
                                    <i class="iconfont icon-jia"></i>
                                </div>
                                <div class="btn edit" @click.stop="openEC(item)">
                                    <i class="iconfont icon-bianji"></i>
                                </div>
                            </div>
                        </div>
                        <div class="add_btn" @click="openAC">
                            <i class="iconfont icon-jia"></i>
                            <span>新增收藏夹</span>
                        </div>
                    </div>
                    <div class="list">
                        <div class="all_send">
                            <el-checkbox label="全选此收藏夹" class="all" v-if="currentFavoriteId" v-model="all" @change="allChange" />
                            <div class="send" @click="openSend"><i class="iconfont icon-fasongyoujian"></i><span>发送报告</span></div>
                        </div>
                        <ul>
                            <li v-for="item in listData" :key="item.articleId" @click="toDetails(item)">
                                <el-checkbox class="checkbox" v-if="currentFavoriteId" v-model="item.checked" @click.stop @change="(e) => checkedChange(e, item)" />
                                <h1>{{ item.articleTitle }}</h1>
                                <p>{{ item.description }}</p>
                                <div class="info">
                                    <span>{{ item.releaseName }}</span>
                                    <div class="ri">
                                        <span>{{ item.showTime }}</span>
                                    </div>
                                </div>
                                <div class="operate">
                                    <div class="btn coll" @click.stop="openCancel(item)"><i class="iconfont icon-shoucang"></i></div>
                                    <div class="btn move" @click.stop="openM(item)"><i class="iconfont icon-yidong"></i></div>
                                </div>
                            </li>
                        </ul>
                        <div class="page_box" v-if="listData.length">
                            <el-pagination small background layout="prev, pager, next" :total="total" class="pagination" v-model:current-page="query.pageNum" :page-size="query.pageSize" />
                        </div>
                        <el-empty description="暂无数据" v-if="!listData.length" />
                    </div>
                </div>
            </main>
        </BgContainer>
    </div>
    <!-- 移动到收藏夹弹框 -->
    <MoveDialog
        :show="showM"
        :favoriteList="favoriteList"
        :row="rowM"
        @close="closeM"
        @success="
            () => {
                setListData();
                getFavoriteList();
            }
        "
    />
    <!-- 新增收藏夹 -->
    <AddCollDialog :show="showAC" @close="closeAC" @success="getFavoriteList" />
    <!-- 编辑收藏夹 -->
    <EditCollDialog :show="showEC" :row="rowEC" @close="closeEC" @success="getFavoriteList" />
    <!-- 删除收藏夹 -->
    <DelCollDialog :show="showDC" :row="rowDC" @close="closeDC" @success="getFavoriteList" />
    <!-- 取消收藏 -->
    <CancelCollDialog :show="showCancel" :row="rowCancel" @close="closeCancel" @success="handleCancelSuccess" />
    <!-- 发送报告 -->
    <SendDialog :show="showSend" :groupDict="groupDict" :favoriteId="currentFavoriteId" :articleIdList="checkedList" @close="closeSend" />
</template>

<script setup>
import BgContainer from "@/components/customer-week-report/pc/BgContainer.vue";
import ReportHeader from "@/components/customer-week-report/pc/ReportHeader.vue";
import PageTitle from "@/components/customer-week-report/pc/PageTitle.vue";
import ShowYear from "@/components/customer-week-report/pc/ShowYear.vue";
import ShowMonth from "@/components/customer-week-report/pc/ShowMonth.vue";
import { useRouter, useRoute } from "vue-router";
import useColl from "./useColl";
import HomeHeader from "@/components/common/HomeHeader.vue";
import MoveDialog from "./move-dialog/index.vue";
import useMove from "./move-dialog/useMove";
import EditCollDialog from "./edit-coll-dialog/index.vue";
import useEditColl from "./edit-coll-dialog/useEditColl";
import DelCollDialog from "./del-coll-dialog/index.vue";
import useDelColl from "./del-coll-dialog/useDellColl";
import useArtcleList from "./useArtcleList";
import AddCollDialog from "./add-coll-dialog/index.vue";
import useAddColl from "./add-coll-dialog/useAddColl";
import CancelCollDialog from "@/components/cancel-coll-dialog/index.vue";
import useCancelColl from "@/components/cancel-coll-dialog/useCancelColl";
import SendDialog from "./send-dialog/index.vue";
import useSend from "./send-dialog/useSend";
import useDict from "./useDict";

const $route = useRoute();
const $router = useRouter();
const year = new Date().getFullYear();
const month = new Date().getMonth() + 1;

// 收藏夹
const { favoriteList, currentFavoriteId, getFavoriteList } = useColl();

// 文章列表
const { query, total, listData, setListData, all, checkedList, checkedChange, allChange } = useArtcleList({ currentFavoriteId });

// 移动到收藏夹
const { show: showM, open: openM, close: closeM, row: rowM } = useMove();

// 新增收藏夹
const { show: showAC, open: openAC, close: closeAC } = useAddColl();

// 编辑收藏夹
const { show: showEC, open: openEC, close: closeEC, row: rowEC } = useEditColl();

// 删除收藏夹
const { show: showDC, open: openDC, close: closeDC, row: rowDC } = useDelColl();

// 取消收藏
const {
    show: showCancel,
    open: openCancel,
    close: closeCancel,
    row: rowCancel,
    handleCancelSuccess,
} = useCancelColl(() => {
    getFavoriteList(); // 刷新收藏夹
    setListData(); // 刷新文章列表
});

// 发送报告
const { show: showSend, open: openSend, close: closeSend } = useSend({ currentFavoriteId });

// 字典
const { groupDict } = useDict();

// 跳转详情
function toDetails(e) {
    const routeQuery = {
        ...$route.query,
        articleId: e.articleId,
        tagId1: e.tagId,
        pageNum: query.pageNum,
        pageSize: query.pageSize,
        coll: "true",
    };
    $router.push({
        path: `/details`,
        query: routeQuery,
    });
}
</script>

<style lang="scss" scoped>
.container {
    background-color: #e6e6e6;
    min-height: calc(100vh - var(--home-header-height));
    padding-top: var(--home-header-height);

    .show_date {
        border-top: 1px solid var(--week-primary-color);
        position: absolute;
        top: 60px;
        right: 44px;
        padding-top: 30px;
        padding-right: 100px;
        padding-left: 10px;
        display: flex;
        align-items: center;
    }

    .small_logo {
        position: absolute;
        top: 87px;
        right: 52px;
    }

    main {
        width: 100%;
        min-height: calc(100vh - var(--week-pc-header-height));
        background-color: #f5f5f5;
        box-shadow: 0 0 20px #ccc;
        padding: 46px 80px;

        .title_row {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .second_and_list {
            display: flex;
            margin-top: 32px;

            .second_plate {
                --pr: 46px;
                width: calc(149px + var(--pr));
                padding-right: var(--pr);

                .all {
                    line-height: 34px;
                    background-color: var(--week-primary-color);
                    color: #fff;
                    font-size: 20px;
                    font-weight: bold;
                    cursor: pointer;
                    text-align: center;
                }

                .li {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-top: 20px;
                    padding-bottom: 10px;
                    padding-left: 8px;
                    position: relative;
                    cursor: pointer;

                    &::after {
                        display: block;
                        content: "";
                        width: 100%;
                        height: 1px;
                        background-color: #cbcbcb;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                    }

                    h1 {
                        font-weight: 400;
                        color: #818181;
                        font-size: 16px;
                    }

                    span {
                        color: #818181;
                        font-size: 14px;
                    }

                    &.active {
                        h1,
                        span {
                            color: #000;
                            font-weight: bold;
                        }

                        &::after {
                            height: 3px;
                            background-color: var(--week-primary-color);
                        }
                    }
                    .oper {
                        position: absolute;
                        display: none;
                        top: 24px;
                        left: -42px;
                        .btn {
                            display: flex;
                            width: 16px;
                            height: 16px;
                            background-color: #e6e6e6;
                            border-radius: 2px;
                            cursor: pointer;
                            align-items: center;
                            justify-content: center;
                            &:first-child {
                                margin-right: 10px;
                            }
                            .iconfont {
                                font-size: 12px;
                                color: #979797;
                            }
                            &.del {
                                .iconfont {
                                    transform: rotate(45deg);
                                }
                            }
                            &.edit {
                                background-color: #f4e8e2;
                                .iconfont {
                                    color: var(--primary-color);
                                }
                            }
                        }
                    }
                    &:hover {
                        .oper {
                            display: flex;
                        }
                    }
                }
                .add_btn {
                    height: 40px;
                    border-radius: 2px;
                    background-color: #f5f5f5;
                    border: 1px solid #ff5a00;
                    margin-top: 24px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    .iconfont {
                        color: #979797;
                        font-size: 22px;
                    }
                    span {
                        color: var(--primary-color);
                        padding-left: 9px;
                    }
                    &:hover {
                        opacity: 0.8;
                    }
                }
            }
        }

        .list {
            min-height: 800px;
            background-color: #fff;
            flex: 1;
            box-shadow: 2.7px 7.5px 8.19px 0.81px rgba(0, 0, 0, 0.06);
            padding: 0 46px;
            padding-bottom: 33px;
            .all_send {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-top: 20px;
                .all {
                    position: relative;
                    left: -22px;
                }
                .send {
                    border: 1px solid var(--primary-color);
                    padding: 6px 15px;
                    display: flex;
                    align-items: center;
                    color: var(--primary-color);
                    border-radius: 2px;
                    cursor: pointer;
                    position: relative;
                    right: -24px;
                    margin-left: auto;
                    .iconfont {
                        margin-right: 5px;
                    }
                }
            }

            ul {
                padding-bottom: 50px;

                li {
                    padding-top: 35px;
                    padding-bottom: 24px;
                    border-bottom: 1px solid #cecece;
                    position: relative;
                    padding-right: 54px;
                    cursor: pointer;
                    position: relative;
                    .checkbox {
                        position: absolute;
                        left: -22px;
                        top: 29px;
                    }

                    h1 {
                        font-size: 16px;
                        color: #000;
                        font-family: "SourceHanSansCN-Normal-Alphabetic";
                    }

                    p {
                        color: #727272;
                        font-size: 12px;
                        margin-top: 20px;
                        line-height: 1.8em;
                    }

                    .info {
                        display: flex;
                        justify-content: space-between;
                        padding-top: 11px;

                        span {
                            font-size: 12px;
                            color: #999;
                        }
                        .ri {
                            display: flex;
                            align-items: center;
                            .coll {
                                margin-left: 16px;
                                cursor: pointer;
                                .iconfont {
                                    color: #999;
                                    font-size: 18px;
                                }
                                &.active {
                                    .iconfont {
                                        color: var(--primary-color);
                                    }
                                }
                            }
                        }
                    }

                    .operate {
                        position: absolute;
                        top: 37px;
                        right: 0;
                        display: flex;
                        .btn {
                            width: 18px;
                            height: 18px;
                            background-color: #f5f5f5;
                            border-radius: 2px;
                            cursor: pointer;
                            margin-left: 8px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            .iconfont {
                                font-size: 14px;
                            }
                            &.coll {
                                background-color: #ffeee4;
                                .iconfont {
                                    color: var(--primary-color);
                                }
                            }
                            &.move {
                                .iconfont {
                                    font-size: 16px;
                                    color: #929292;
                                }
                            }
                        }
                    }

                    &:hover {
                        h1 {
                            text-decoration: underline;
                        }
                    }
                }
            }

            .page_box {
                display: flex;
                align-items: center;
                justify-content: center;

                :deep(.el-pagination .el-pager li) {
                    border-radius: 50%;
                    background-color: #cbcbcb;
                    color: #fff;
                    margin: 0 5px;
                }

                // 上下一页样式修改
                :deep(.el-pagination .btn-prev),
                :deep(.el-pagination .btn-next) {
                    background-color: #cbcbcb;
                    color: #fff;
                }

                // 上下一页不可点时，hover字体颜色修改
                :deep(.el-pagination .btn-prev:not(:disabled):hover),
                :deep(.el-pagination .btn-next:not(:disabled):hover) {
                    color: var(--week-primary-color);
                }

                :deep(.el-pagination.is-background .el-pager li:not(.disabled).active) {
                    background-color: var(--week-primary-color);
                }

                :deep(.el-pagination.is-background .el-pager li:not(.active):hover) {
                    color: var(--week-primary-color);
                }

                :deep(.btn-quicknext) {
                    display: inline-flex;
                    align-items: center;
                }
            }
        }
    }
}
</style>
